import React from 'react';
import styled from 'styled-components';
import { mediaQuery } from '@/utils/helpers';
import { config } from '@keytrade/functions';
import { DateTime } from 'luxon';
const { list: colors } = config.colors;
const { getFont } = config.fonts;

const CalendarDate = styled.div`
  width: 48px;
  height: 48px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${colors.GreyLight};
  background-color: ${colors.White};
  border-radius: 4.8px;
  ${mediaQuery.md(`
    width: 60px;
    height: 60px;
    border-radius: 6px;
    border: 1px solid ${colors.Grey};
  `)}
`;

const Month = styled.div`
  font-size: 10.8px;
  text-transform: uppercase;
  letter-spacing: 0.67px;
  color: ${colors.BlueNight};
  ${mediaQuery.md(`
    font-size: 1.35rem;
  `)}
`;

const Year = styled.div`
  font-size: 20.39px;
  line-height: 1;
  color: ${colors.BlueDark};
  font-family: ${({ theme }) => getFont(theme, 'bold')};
  ${mediaQuery.md(`
    font-size: 2.55rem;
  `)}
`;

export type SeminarDateType = {
  datetime: any;
  locale: any;
};

const SeminarDate: React.FC<SeminarDateType> = ({ datetime, locale }) => {
  return (
    <CalendarDate>
      <Month>
        {DateTime.fromISO(datetime.date)
          .setLocale(locale)
          .monthLong.substring(0, 3)}
      </Month>
      <Year>{DateTime.fromISO(datetime.date).day}</Year>
    </CalendarDate>
  );
};

export default SeminarDate;
